import { Global } from "@emotion/react";

import RobotoBold from "@assets/fonts/Roboto-Bold.ttf";
import RobotoMedium from "@assets/fonts/Roboto-Medium.ttf";
import RobotoRegular from "@assets/fonts/Roboto-Regular.ttf";
import RobotoSemiBold from "@assets/fonts/Roboto-SemiBold.ttf";

export const FontFaces = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        src: url(${RobotoBold}) format('truetype');
        font-display: swap;
      }

      @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        src: url(${RobotoSemiBold}) format('truetype');
        font-display: swap;
      }

      @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        src: url(${RobotoMedium}) format('truetype');
        font-display: swap;
      }

      @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        src: url(${RobotoRegular}) format('truetype');
        font-display: swap;
      }
    `}
  />
);
